import { Component, OnInit } from '@angular/core';
import { IOption } from 'ng-select';

@Component({
  selector: 'app-vir',
  templateUrl: './vir.component.html',
  styleUrls: ['./vir.component.scss']
})
export class VirComponent implements OnInit {
  loading:boolean = true;
  myCategoryOptions: Array<IOption> = [{'value':'0','label':'both'},{'value':'2','label':'Sales'},{'value':'3','label':'Workshop'}]
  selectedCategory='0';
  constructor() { }

  ngOnInit() {
    this.loading=false;
  }

  fromDateChangeDropDown() {
    // let searchMediaObj = {
    //   "category": this.selectedCategory,
    //   "userId": localStorage.getItem('userId'),
    //   "fromDate": moment(this.fromDate).format('YYYY-MM-DD'),
    //   "toDate": moment(this.toDate).format('YYYY-MM-DD'),
    //   "searchType":"all"
    // }
    // this.getSearchMediaAPICallDetails(searchMediaObj);
  }

}



// WEBPACK FOOTER //
// ./client/app/vir/vir.component.ts